import * as Sentry from "@sentry/react";

const isDev = process.env.NODE_ENV === "development";

interface SentryConfig {
    dsn: string;
    tracePropagationTargets?: string[];
    enableReplayCapture?: boolean;
}

const initSentry = (config: SentryConfig) => {
    if (isDev) return;
    if (Sentry.isInitialized()) return;
    Sentry.init({
        dsn: config.dsn,
        environment: window.location.hostname.replace('www.', ''),
        integrations: [
            Sentry.browserTracingIntegration(),
            ...(config.enableReplayCapture ? [Sentry.replayIntegration()] : []),
        ],
        ...(config.tracePropagationTargets && {
            tracePropagationTargets: config.tracePropagationTargets,
        }),
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: isDev ? 1.0 : 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
};

export default initSentry;